import React from 'react'

const CaesarCipherAlgo = () => {
    return (
        <div>
            <h3>Encryption:</h3>
            <ol>
                <li>Choose a shift value (key) for the cipher. This value determines how many positions each letter in the plaintext will be shifted.</li>
                <li>Take the plaintext message you want to encrypt.</li>
                <li>For each letter in the plaintext:
                    <ol type='a' style={{ marginLeft: 30 }}>
                        <li>Determine the alphabetical position of the letter (e.g., A=0, B=1, ..., Z=25).</li>
                        <li>Add the shift value to the alphabetical position.</li>
                        <li>For every resultant value x, take 'x mod 26'.</li>
                        <li>Convert the resulting alphabetical position back to a letter.</li>
                        <li>Append the resulting letter to the ciphertext.</li>
                    </ol>
                </li>
                <li>The resulting ciphertext is the encrypted message.</li>
            </ol>
            <br />
            <h3>Decryption:</h3>
            <ol>
                <li>Take the ciphertext you want to decrypt.</li>
                <li>Choose the same shift value (key) that was used for encryption.</li>
                <li>For each letter in the ciphertext:
                    <ol type='a' style={{ marginLeft: 30 }}>
                        <li>Determine the alphabetical position of the letter.</li>
                        <li>Subtract the shift value from the alphabetical position.</li>
                        <li>If the result is negative, add 26 to it.</li>
                        <li>Convert the resulting alphabetical position back to a letter.</li>
                        <li>Append the resulting letter to the plaintext.</li>
                    </ol>
                </li>
                <li>The resulting plaintext is the decrypted message.</li>
            </ol>
        </div>

    )
}

export default CaesarCipherAlgo